import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@material-ui/core";
import HeadOrder from "../orderDetailsForm/headOrder";
import DetailOrder from "../orderDetailsForm/detailOrder";
import Totals from "../orderDetailsForm/totals";
import RedButton from "../../components/buttons/redButton";
import { LoaderSpinner } from "../../components/spinner/loader";

const OrderDetailsView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location?.state;
  
  const [order, setOrder] = useState({});
  const [orderDetails, setOrderDetails] = useState([]);
  const [totalExpenses, setTotalExpenses] = useState(0);
  const [totalExpensesWithIva, setTotalExpensesWithIva] = useState(0);
  const [totalExpensesWithIva21, setTotalExpensesWithIva21] = useState(0);
  const [totalExpensesWithIva105, setTotalExpensesWithIva105] = useState(0);
  const [loading, setLoading] = useState(false);
  // Siempre deshabilitar edición en esta vista
  const [disableEdition, setDisableEdition] = useState(true);
  const [deletePrevColumnsId, setDeletePrevColumnsId] = useState([]);

  useEffect(() => {
    // Verificamos si los datos vienen de la estructura anterior o de la nueva
    if (data?.order) {
      setOrder(data.order);
      setOrderDetails(data.order.orderDetails || data.order.details || []);
    } else if (data?.orderData) {
      // Nueva estructura de datos desde ticketsScreen
      setOrder(data.orderData);
      setOrderDetails(data.orderData.orderDetails || data.orderData.details || []);
    }
  }, [data]);

  return loading ? (
    <div
      style={{
        width: "100%",
        height: "200px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LoaderSpinner />
    </div>
  ) : (
    <Box className="order-details-form-container order-details-form-page">
      <HeadOrder
        order={order}
        setOrder={setOrder}
        disableEdition={disableEdition}
      />
      <DetailOrder
        order={order}
        orderDetails={orderDetails}
        setOrderDetails={setOrderDetails}
        setTotalExpenses={setTotalExpenses}
        setTotalExpensesWithIva={setTotalExpensesWithIva}
        setTotalExpensesWithIva21={setTotalExpensesWithIva21}
        setTotalExpensesWithIva105={setTotalExpensesWithIva105}
        disableEdition={disableEdition}
        setDeletePrevColumnsId={setDeletePrevColumnsId}
      />
      <Totals
        totalExpenses={totalExpenses}
        totalExpensesWithIva={totalExpensesWithIva}
        iva21={totalExpensesWithIva21}
        iva105={totalExpensesWithIva105}
      />
      <Box className="buttons-container">
        <RedButton
          title="Volver"
          style={{ backgroundColor: "#434343" }}
          onClick={() => navigate(-2)}
        />
      </Box>
    </Box>
  );
};

export default OrderDetailsView; 